export default class CitySelect {

  constructor(args) {
    this.container = $(args['container']);
    this.resultsContainer = $(args['resultsContainer']);
    this.loader = $(args['loader']);
    this.input = $(args['input']);
    this.onChangeCallback = args['onChange'];
    this.onResetCallback = args['onReset'];
    this.showResetButton = false;
    this.init();
  }

  init() {
    this.addEventlisteners();
  }

  addEventlisteners() {
    var that = this;

    $(this.input).on('input', function() {
      let term = $(this).val();

      if (term.length > 2) {
        that.searchCity(term);
      }

      if (term.length > 0) {
        $('.c-city-select__reset').addClass('c-city-select__reset--active');
      }
    });

    $(window).click(function() {
      $('.c-city-select').removeClass('c-city-select--active');
    });

    this.input.focus(function(event) {
      event.preventDefault();
      event.stopPropagation();
      $(that.resultsContainer).html('');
      $('.c-city-select').addClass('c-city-select--active');
    });

    this.input.click(function(event) {
      event.preventDefault();
      event.stopPropagation();
      $(that.resultsContainer).html('');
      $('.c-city-select').addClass('c-city-select--active');
    });

    $('.c-city-select__reset').click(function(event){
      event.preventDefault();
      event.stopPropagation();
      that.reset();
      that.input.focus();
    });
  }

  updateEventlisteners() {
    var that = this;

    $('.c-city-select__result').on('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      that.onChangeCallback($(this).attr('data-value'), $(this).attr('data-name'));
      $(that.input).val($(this).attr('data-title'));
      $('.c-city-select').removeClass('c-city-select--active');
      that.container.removeClass('c-city-select--loaded');
    });
  }

  searchCity(term) {
    const data = null;
    var that = this;

    this.isLoadingCities(true);

    const sendData = Object.assign( {
      'dataType': 'json',
      'action': 'search_cities',
      'city_search_term': term,
    }, data);
    $.ajax({
      type: 'POST',
      data: sendData,
      url: ajax_args.url,
      success: function (response) {
        that.resultsContainer.html(response);
        that.updateEventlisteners();
        that.isLoadingCities(false);
        that.container.addClass('c-city-select--loaded');
      },
      error: function (response) {
        console.log(response);
        that.isLoadingCities(false);
        that.container.removeClass('c-city-select--loaded');
      },
    });
  }

  isLoadingCities(loading) {
    var that = this;

    if (loading) {
      $('.c-city-select__reset').removeClass('c-city-select__reset--active');
      $('.c-city-select').addClass('c-city-select--loading');
    } else {
      setTimeout(function(){
        $('.c-city-select').removeClass('c-city-select--loading');
      }, 500);
      setTimeout(function(){
        if ($(that.input).val() != null && $(that.input).val() != '') {
          $('.c-city-select__reset').addClass('c-city-select__reset--active');
        }
      }, 750);
    }
  }

  reset(fireCallback = true) {
    this.isLoadingCities(false);

    if ($(this.input).val() != null) {
      $(this.input).val(null);
    }
    if (fireCallback) {
      this.onResetCallback();
    }
    $('.c-city-select__reset').removeClass('c-city-select__reset--active');
    this.container.addClass('c-city-select--loaded');
  }
}



// WEBPACK FOOTER //
// ./scripts/components/city-select.js